import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import EnhancedStatsComponent from './js/enhanced-stats.component';

ComponentsFactory.getInstance().define('enhanced-stats-component', EnhancedStatsComponent);
